import { ArrowLeftIcon, PlusIcon } from '@heroicons/react/24/solid';
import { Button, Link } from '@heroui/react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import OrganizationAccountsList from '@/app/components/organization/organization-accounts-list.tsx';
import { usePageLoading } from '@/app/components/page-loading';
import { useAuth } from '@/app/hooks/auth-provider';
import { Divider } from '@/primitives/divider.tsx';
import { Subheading } from '@/primitives/heading.tsx';
import { useFetchOrganizationQuery } from '@/slices/organization-api-slice';
import { hasPermission } from '../../../types/constants.ts';
import { type StaffMemberModel, StaffRoleEnum } from '../../../types/staff-member.type.ts';
import { UserTypeEnum } from '../../../types/user-type.ts';
import OrganizationForm from './organization-form';

const EditOrganization = () => {
  const params = useParams();
  const { data, isLoading } = useFetchOrganizationQuery(params.key);
  const { user } = useAuth();

  const { showPageLoading, hidePageLoading } = usePageLoading();
  const navigate = useNavigate();

  useEffect(() => {
    isLoading
      ? showPageLoading('loading-organization-edit')
      : hidePageLoading('loading-organization-edit');
  }, [isLoading]);

  return (
    <div className='flex flex-col gap-10'>
      <div className='flex items-center gap-2'>
        <Button isIconOnly variant='flat' color='primary' onPress={() => navigate(-1)}>
          <ArrowLeftIcon className='size-4' />
        </Button>
        <h4 className='text-primary-600'>Update Organization</h4>
      </div>
      <OrganizationForm organization={data} />
      <Divider />
      <div className='flex flex-col gap-5'>
        <div className='flex justify-between'>
          <Subheading className='pb-5'>Accounts</Subheading>
          {(user?.userType === UserTypeEnum.Admin ||
            (user?.userType === UserTypeEnum.StaffMember &&
              hasPermission(
                user as StaffMemberModel,
                StaffRoleEnum.OrganizationAdministrator,
              ))) && (
            <div>
              <Button as={Link} color='primary' variant='solid' href={`/account/new/${data?.key}`}>
                <PlusIcon /> Add Account
              </Button>
            </div>
          )}
        </div>
        <OrganizationAccountsList organizationKey={data?.key} />
      </div>
    </div>
  );
};

export default EditOrganization;
